import React from 'react'

import {MentionOption} from "../option"
import Mention from "./mention/mention"
import {EntityType} from "../../../../../gd/const/item"
import ProjectSession from "../../../../../model2/project/project-session";

type Props = {
    isEditMode? : boolean
    mention     : MentionOption

    className? : string
}

export default function MentionComponent(props: Props): JSX.Element {
    const project: ProjectSession | null = props.mention.type === EntityType.PROJECT ? gd.session.projects.get(props.mention.data.id) : null

    const enableLink = !props.isEditMode &&
        [EntityType.TASK,EntityType.DOCUMENT,EntityType.PROJECT].includes(props.mention.type)

    // no new window link for project links and categories (groups)
    const showOpenWindow = enableLink &&
        !project?.isLink &&
        !project?.isCategory


    const onClick = (e:any) => {
        e.stopPropagation()
        if (!enableLink) return

        switch (props.mention.type) {
            case EntityType.TASK       :
                gd.goTo('t/'+props.mention.data.id)
                break

            case EntityType.DOCUMENT   :
                gd.goTo('n/'+props.mention.data.id)
                break

            case EntityType.USER       :
                gd.goTo('u/'+props.mention.data.id)
                break

            case EntityType.PROJECT    :
                if (project) {
                    project.goTo()
                } else {
                    gd.goTo('p/'+props.mention.data.id)
                }
                break
        }
    }

    const onOpenNewWindow = (e:any) => {
        e.stopPropagation()
        if (!enableLink) return

        switch (props.mention.type) {
            case EntityType.TASK       :
                window.open('https://www.goodday.work/t/'+props.mention.data.id)
                break

            case EntityType.DOCUMENT   :
                window.open('https://www.goodday.work/n/'+props.mention.data.id)
                break

            case EntityType.USER       :
                window.open('https://www.goodday.work/u/'+props.mention.data.id)
                break

            case EntityType.PROJECT    :
                window.open('https://www.goodday.work/p/'+props.mention.data.id)
                break
        }
    }

    const classes = Classes("mention-option-component lexical-mention", props.className)

    return (
        <div className={classes} onClick={gd.viewMode === 'shared-view' ? onOpenNewWindow : onClick}>
            <Mention mention={props.mention}/>
            {showOpenWindow && <div className="mention-open-new-window i5-open-new-window" onClick={onOpenNewWindow}/>}
        </div>
    );
}
